export default function is(value) {
    return function isValue(value2) {
        return value === value2;
    };
}
//# sourceMappingURL=is.js.map